import ListFooterComponent from "src/components/ListFooterComponent";
import { useGatheringStore } from "src/contexts/GatheringContext";

const GatheringHomeLoadingFooter = ({ loading }: { loading: boolean }) => {
	const loadingForNavBar = useGatheringStore((state) => state.loadingForNavBar);
	return <ListFooterComponent loading={loading && !loadingForNavBar} />;
};
export default GatheringHomeLoadingFooter;
